// Patient-facing copy for the reschedule flow. Plain English, and every message says what
// to do next and who to call.

export const RESCHEDULE_BLOCKED_REASON = {
  NO_APPOINTMENT: 'NO_APPOINTMENT',
  CANCELLED: 'CANCELLED',
  NOT_AT_HOME: 'NOT_AT_HOME',
  INSIDE_NOTICE_WINDOW: 'INSIDE_NOTICE_WINDOW',
};

/** Why the Reschedule button is not shown, as a message for the pre-appointment page. */
export const getRescheduleBlockedMessage = (reason, { phone }) => {
  switch (reason) {
    case RESCHEDULE_BLOCKED_REASON.INSIDE_NOTICE_WINDOW:
      return `Your appointment is less than 2 business days away, so it can't be changed online. Please call us on ${phone}.`;
    case RESCHEDULE_BLOCKED_REASON.NOT_AT_HOME:
      return `This appointment can't be changed online. Please call us on ${phone} to change it.`;
    case RESCHEDULE_BLOCKED_REASON.CANCELLED:
      return `This appointment has been cancelled. Please call us on ${phone} to book a new one.`;
    default:
      return `To change your appointment, please call us on ${phone}.`;
  }
};

/** Message after a failed reschedule request, from the patient-api error code. */
export const getRescheduleErrorMessage = (errorCode, { phone }) => {
  switch (errorCode) {
    case 'SLOT_TAKEN':
      return 'Sorry, that time has just been taken. Please choose another time.';
    case 'START_TOO_SOON':
      return 'Please choose a time from tomorrow onwards.';
    case 'INVALID_COVER':
      return 'Please check your Medicare or DVA card details and try again.';
    case 'NOT_ELIGIBLE':
      return `This appointment can no longer be changed online. Please call us on ${phone}.`;
    case 'RESCHEDULE_CONFLICT':
      return 'Your appointment is already being changed, or was just changed. Please refresh the page to see its current time.';
    case 'SESSION_EXPIRED':
      return 'For your privacy this page has timed out. Please refresh the page and enter your date of birth again.';
    case 'WORKFLOW_UPDATE_FAILED':
      return `Your appointment time has been changed, but we could not finish updating your booking. Our team has been told and will contact you. If you have questions, call us on ${phone}.`;
    default:
      return `Sorry, we could not change your appointment. Please try again, or call us on ${phone}.`;
  }
};
